import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { Link, useNavigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import { QRCodeCanvas } from 'qrcode.react';
import { useRef } from 'react';
import { set } from 'react-hook-form';
import ReactPaginate from 'react-paginate'; 
import Select from 'react-select';
import Loader from '../Chargers/Loader';





const RFID = () => {
  document.title = "RFID Management | RFID";

  let params = useParams();
  
  let rfidID = params?.fid;

  console.log("rfidID", rfidID);



  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [States, setStates] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [RFIDData, setRFIDData] = useState([]);
  const [filteredRFIDData, setFilteredRFIDData] = useState([]);
  const [section, setSection] = useState([]);
  const [cities, setcities] = useState([]);
  const [selectedcity, setSelectedcity] = useState('');
  const [SelectedState, setSelectedState] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [Users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [qrNumber, setQRnumber] = useState([]);
  const [importFileData, setImportFileData] = useState(null);
  const [statusListing, setStatusListing] = useState([]);
  const [RfidStatuses, setRfidStatuses] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLimit, setselectedLimit] = useState("");
  const [Limit, setLimit] = useState({});
  const [page, setPage] = useState(1); 
  const [pageCount, setPageCount] = useState(0); 
  const [StationData, setStationData] = useState([]);
  const [selectedStation, setselectedStation] =  useState("");
  const [selectedFilteredUser, setSelectedFilteredUser] = useState("");
  const FetchStationsData = async () => {
    setLoading(true);
    const url = `${BaseURL}/station`;
try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      if (res && res.data.data) {
        setStationData(res.data.data);
       }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchStationsData(); // Pass current page and search query to the fetch function
  }, []); 
  console.log("StationData", StationData);


  let navigate = useNavigate();

  // State for the popup input value
  const [popupInput, setPopupInput] = useState('');
  const [selectedUser, setSelectedUser] = useState('');
  const [searchTerms, setSearchTerms] = useState({
    backend_rfid_code: '',
    serial_number: '',
    mobileNumber: '',
    assignUser: '',
    assignDate: '',
    qrCode: '',
    linkWith: '',
    cardLimit: '',
    assignFrom: '',
     status: '',
    createdDate: '',
  });
  const handleSelectUserChange = (selectedOption) => {
    setSelectedFilteredUser(selectedOption?.value); // Save the selected user
    // You can perform other actions here, such as updating another state or making API calls
  };
  const handleSelectStationChange = (selectedOption) => {
    setselectedStation(selectedOption?.value); // Save the selected user
    // You can perform other actions here, such as updating another state or making API calls
  };

  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value,
    }));
  };
  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/rfid-record/rfid-list`);
    }


    const displayedData = filteredRFIDData.filter((user) => {
      return (
        (searchTerms?.backend_rfid_code === '' || 
          (user?.backend_rfid_code && user?.backend_rfid_code.toLowerCase().includes(searchTerms?.backend_rfid_code.toLowerCase()))) &&
        (searchTerms?.serial_number === '' || String(user?.serial_number)?.includes(searchTerms?.serial_number)) &&
        (searchTerms?.mobileNumber === '' || user?.assignedUser?.mobile.includes(searchTerms.mobileNumber)) &&
        (searchTerms?.assignUser === '' || user?.assignedUser?.name.toLowerCase().includes(searchTerms.assignUser.toLowerCase())) &&
        (searchTerms?.assignDate === '' || user?.assign_date?.includes(searchTerms.assignDate)) &&
        (searchTerms?.qrCode === '' || user?.UPI_url_link?.toLowerCase().includes(searchTerms.qrCode.toLowerCase())) &&
        (searchTerms?.linkWith === '' || user?.QrLink?.toLowerCase().includes(searchTerms.linkWith.toLowerCase())) &&
        (searchTerms?.cardLimit === '' || user?.limit?.toString().includes(searchTerms.cardLimit)) &&
        (searchTerms?.assignFrom === '' || user?.assign_user_id?.toString().includes(searchTerms.assignFrom)) &&
        (searchTerms?.status === '' || user?.status?.toLowerCase().includes(searchTerms.status.toLowerCase())) &&
        (searchTerms?.createdDate === '' || user?.createdAt?.includes(searchTerms.createdDate))
      );
    });
    
  console.log("displayedData-----------", displayedData);


  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  
    const fileInputRef = useRef(null);
  
    const handleButtonClick = () => {
      fileInputRef.current.click(); // Trigger the hidden file input click
    };
  
    const handleFileChange = async (event) => {
      const file = event.target.files[0];
      console.log('Selected file:', file);
      setImportFileData(file); // Store the file in state
    
      if (file) {
        const formData = new FormData();
        formData.append('file', file); // 'file' should match the backend field name
    
        try {
          const confirmation = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to upload this file?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, upload it!',
            cancelButtonText: 'No, cancel!',
          });
    
          if (confirmation.isConfirmed) {
            const response = await fetch(`${BaseURL}/rfid/import-excel`, {
              method: 'POST',
              body: formData,
              headers: {
                Authorization: `Bearer ${uniqueToken}`,
                // 'Content-Type' is automatically set when using FormData
              },
            });
    
            const data = await response.json();
            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: data.message,
              });
            }
          } else {
            Swal.fire({
              icon: 'info',
              title: 'Cancelled',
              text: 'Your file upload has been cancelled.',
              showConfirmButton: false,
              timer: 1500,
            });
          }
        } catch (error) {
          console.error('Error during file upload:', error);
          Swal.fire({
            icon: 'error',
            title: 'Upload Failed',
            text: 'An error occurred during file upload. Please try again later.',
          });
        }
      }
    };
    
   
  const handleqrgeneratenumber = (e) => {
    setQRnumber(e.target.value);
  }

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
  
    // Always reset to page 1 when searching
    setPage(1); // Reset to the first page
  
    setLoadings(true); // Set loading state to true while fetching
  
    // Construct URL to include the search query and reset page to 1
    var url = `${BaseURL}/rfid/?page=${1}&searchText=${searchQuery}`; // Use & instead of ? for query parameters
    if (rfidID) {
      url += `&rf_id=${encodeURIComponent(rfidID)}`;
    }
    if (selectedStation) {
      url += `&station_id=${encodeURIComponent(selectedStation)}`;
    }
    if (selectedFilteredUser) {
      url += `&user_id=${encodeURIComponent(selectedFilteredUser)}`;
    }
  
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`, // Include the authorization token
        },
      });
  
      if (res && res.data && res.data.data) {
        setFilteredRFIDData(res?.data.data); // Update filtered data
        setTotalCount(res?.data?.totalCount || 0); // Set total count based on the response
        setPageCount(Math.ceil(res?.data?.totalCount / res.data.limit)); // Update page count based on results
      } else {
        setFilteredRFIDData([]); // If no data is returned, set filtered data to empty
        setTotalCount(0); // Set total count to 0 if no data
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoadings(false); // Set loading state to false after fetching
    }
  };
  
  const GenerateQR = async () => {
    setLoading(true); // Start loading
  
    try {
      const qrNumberAsInt = parseInt(qrNumber, 10);
  
      const response = await axios({
        url: `${BaseURL}/razorpay/generateQr`,
        method: 'POST',
        data: {
          generate_qr_number: qrNumberAsInt,
        },
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
  
      if (response.status === 200) {
        
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        fetchRFIDData();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: response?.error,
        });
      }
    } catch (response) {
      const error = response.response?.data?.error
       console.log("error", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error,
      });
      console.error(error);
    } finally {
      setLoading(false); // Stop loading
    }
  };
  
  const fetchRFIDData = async () => {
    setLoadings(true);
    
    const apiEndpoint = `${BaseURL}/rfid/`;
    const queryParams = [`page=${page}`];
    if (rfidID) {
      queryParams.push(`rf_id=${rfidID}`);
  }
  const apiUrl = `${apiEndpoint}${queryParams.length ? '?' + queryParams.join('&') : ''}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      console.log("response", response);
      setRFIDData(response.data.data || []);
      setFilteredRFIDData(response.data.data || []); // Initially set filteredRFIDData to the full data set
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit));
      setTotalCount(response.data.totalCount || 0);
    } catch (error) {
      console.error("Error fetching RFIDData:", error);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    fetchRFIDData();
  }, [page]);

  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };

  const DeleteFunction = async (id) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (results) => {
      const DeleteRFIDApi = `${BaseURL}/rfid/delete`;
  
      if (results.value) {
        try {
          const res = await axios.put(`${DeleteRFIDApi}/${id}`, {}, {
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              Authorization: `Bearer ${uniqueToken}`,
            },
          });
  
          if (res.data.statusCode === 200) {
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            fetchRFIDData();
          } else {
            Swal.fire({
              icon: "info",
              title: "Notice",
              text: res.data.message || "Unexpected result. Please try again.",
            });
            fetchRFIDData();
          }
  
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "An error occurred while deleting the RFID.",
          });
        }
      }
    });
  };

  const fetchUsers = async () => {
    setLoading(true);
    
    const apiUrl = `${BaseURL}/user/get-all`;

    try {
        const response = await axios.get(apiUrl, {
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`,
            },
        });
        console.log("response", response);
        setUsers(response.data.data || []);
        // setTotalCount(response.data.totalCount || 0);
        setLimit(response?.data?.limit);
    } catch (error) {
        console.error("Error fetching users:", error);
    } finally {
        setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);
  
  console.log("RFIDData", RFIDData);
  console.log("users", Users);

 

  const handleSelectChange = async (rfidId, selectedOption) => {
    const userId = selectedOption?.value;
    const selectedUser = Users.find(user => user?._id === userId);
    setSelectedUser(userId);
  
    const userName = selectedUser?.name || 'NA';
    const walletAmount = selectedUser?.wallet_amount || 'NA';
  
    const assignLimitSwal = async () => {
      return Swal.fire({
        title: 'Assign Limit',
        html: `
          <span>Name</span>: <b>${userName}</b><br/>
          <span>Wallet Amount</span>: <b>${walletAmount}</b>
          <input type="number" id="swal-input1" class="swal2-input" placeholder="Enter card limit" />
        `,
        showCloseButton: true,
        focusConfirm: false,
        preConfirm: () => {
          const inputValue = document.getElementById('swal-input1').value;
          if (!inputValue || isNaN(inputValue) || inputValue <= 0) {
            Swal.showValidationMessage('Please enter a valid limit greater than 0');
            return false;
          }
          setPopupInput(inputValue);
          return { cardLimit: inputValue, userId };
        }
      });
    };
  
    let swalResult = await assignLimitSwal();
  
    while (swalResult.isConfirmed) {
      const { cardLimit } = swalResult.value;
  
      Swal.fire({
        title: 'Assigning User...',
        text: 'Please wait',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      try {
        const response = await axios.put(
          `${BaseURL}/rfid/assignuser/${rfidId}`,
          { user_id: userId, limit: cardLimit },
          { headers: { "Content-type": "application/json; charset=UTF-8", Authorization: `Bearer ${uniqueToken}` } }
        );
  
        Swal.close();
  
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: response.data.message,
          });
  
          setFilteredRFIDData(prevData =>
            prevData.map(item =>
              item._id === rfidId ? { ...item, limit: cardLimit } : item
            )
          );
  
          fetchRFIDData();
          break;
        } else {
          swalResult = await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: response?.data?.message,
          }).then(assignLimitSwal);
        }
      } catch (error) {
        Swal.close();
  
        swalResult = await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || "An unexpected error occurred.",
        }).then(assignLimitSwal);
      }
    }
  };
  const DownloadExcel = async () => {
    setLoading(true); // Show a loader if necessary
  
    try {
      // Make the API request to download the Excel file
      const response = await axios.get(`${BaseURL}/rfid/download-excel`, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
        responseType: 'blob', // Important for handling file downloads
      });
  
      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'rfid_list.xlsx'); // Specify the file name
      document.body.appendChild(link);
      link.click();
      link.remove();
  
      // Optionally show a success message
   
  
    } catch (error) {
      // Handle errors
      console.error("Error downloading Excel file:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false); // Hide the loader
    }
  };
  
  const DownloadBackendCode = async () => {
    setLoading(true); // Show a loader if necessary
  
    try {
      // Make the API request to download the Excel file
      const response = await axios.get(`${BaseURL}/rfid/download-excel/backend-code`, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
        responseType: 'blob', // Important for handling file downloads
      });
  
      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'rfid_backend_list.xlsx'); // Specify the file name
      document.body.appendChild(link);
      link.click();
      link.remove();
  
      // Optionally show a success message
   
  
    } catch (error) {
      // Handle errors
      console.error("Error downloading Excel file:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    } finally {
      setLoading(false); // Hide the loader
    }
  };
  

  //status listing api
  const fetchStatusListing = async () => {
    const apiEndpoint = `${BaseURL}/settings/charger/status`;

    setLoading(true);

    var url = apiEndpoint

    let res = await request({
      url: url,
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Bearer ${uniqueToken}`,
      },
    });

    console.log("res", res);
   
    if (res && res.data) {
      setStatusListing(res.data);
      }

    return [];
  };

  useEffect(() => {
    fetchStatusListing();
  }, []);
    
  
  const handleStatusType = async (event, userId) => {
    const status = event.target.value;
  
    // Update local state
    setRfidStatuses(prevStatuses => ({
      ...prevStatuses,
      [userId]: status
    }));
  
    const url = `${BaseURL}/rfid/changestatus/${userId}`;
  
    // Create JSON payload
    const statusData = { status };
  
    try {
      // Send status as JSON instead of FormData
      const response = await axios.put(url, statusData, {
        headers: {
          "Content-Type": "application/json", // Send as JSON
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message, 
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `${response?.data?.message}. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
//June 10, 2021-April 22, 2022
  console.log("searchtermmmmmmmm------",searchTerms);
  console.log("filteredData", filteredRFIDData);
  console.log("totalcount", totalCount);
console.log("selectedStation", selectedStation);
console.log("selectedFilteredUser", selectedFilteredUser);
  

  console.log("Limit", Limit);
const QR = "upi://pay?ver=01&mode=19&pa=rzptjdevtorindiaprivatelimited@yesbank&pn=Evtorindiaprivatelimited&tr=qr_OtZC8hksA72Dyx&cu=INR&mc=5552&qrMedium=04&tn=PaymenttoEvtorindiaprivatelimited";
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  {/* RFID Management heading and Total RFIDs button */}
  <div className="d-flex align-items-center">
    <h4 style={{ marginRight: "10px" }}>
      RFID Management({totalCount ? totalCount : "Loading..."})
    </h4>
  </div>

  {/* Button group aligned to the right */}
  <div className="d-flex align-items-center">
    <div className="button-group d-flex gap-2">
      {/* Import button */}
      <div>
        <button
          className="drop-marg12 btn"
          style={{
            border: "1px solid black",
            borderRadius: "27%",
            background: "white",
            height: "32px",
           
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 10px", // Correct padding for consistent width
          }}
          onClick={handleButtonClick}
        >
          Import
        </button>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }} // Hide the actual file input
          onChange={handleFileChange}
        />
      </div>
      {/* Export QR button */}
      <button
        className="drop-marg12 btn"
        style={{
          border: "1px solid black",
          borderRadius: "27%",
          background: "white",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 10px", // Adjust padding for consistent width
        }}
        onClick={DownloadBackendCode}
      >
        Export QR
      </button>

      {/* Excel-All button */}
      <button
        className="drop-marg12 btn"
        style={{
          border: "1px solid black",
          borderRadius: "27%",
          background: "white",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 10px", // Adjust padding for consistent width
        }}
        onClick={DownloadExcel}
      >
        Excel-All
      </button>
    </div>
  </div>
</div>


              <hr style={{ marginTop: "5px" }} />

              <div className="row">
                <div className="col-sm-12">
                <form className="form-horizontal" role="form" method="post" style={{ marginTop: "5px" }}>
  <div className="row px-3">
    <div className="col-md-5">
    <div className="form-group d-flex align-items-center">
  <input
    type="text"
    placeholder="Find Data Here"
    value={searchQuery}
    onChange={handleSearchChange}
    className="form-control d-flex"
    style={{
      height: "40px", // Increase height of input
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      marginRight: "10px", // Space between input and select
      width: "300px", // Set a fixed width for the input box
    }}
  />
  
  {/* Wrapper for Select elements */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    {/* First Select Dropdown */}
    <Select
      styles={{
        container: (base) => ({
          ...base,
          width: '200px', // Set a fixed width for the Select dropdown
        }),
        menu: (base) => ({
          ...base,
          width: '200px', // Ensure dropdown menu matches the container's width
        }),
        control: (base) => ({
          ...base,
          width: '200px', // Set width of the control (the input box part)
        }),
      }}
       value={StationData.find((station) => (
        station?.value ===  selectedStation
      
      ))}
      placeholder ="Select Station"
      onChange={handleSelectStationChange}
      options={StationData.map((station) => ({
        value: station._id,
        label: station.station_name,
      }))}
    />

    {/* Second Select Dropdown */}
    <Select
      styles={{
        container: (base) => ({
          ...base,
          width: '200px', // Set a fixed width for the Select dropdown
        }),
        menu: (base) => ({
          ...base,
          width: '200px', // Ensure dropdown menu matches the container's width
        }),
        control: (base) => ({
          ...base,
          width: '200px', // Set width of the control (the input box part)
        }),
      }}
      value={Users.find((user) => (
        Users?.value ===  selectedFilteredUser
    ))}
            placeholder ="Select User"
      onChange={handleSelectUserChange}
      options={Users.map((user) => ({
        value: user._id,
        label: `${user.name}(${user.mobile})`,
      }))}
    />
  </div> {/* End of Select wrapper */}

  {/* Search Button */}
  <button
    type="submit"
    onClick={handleSearchSubmit}
    className="btn btn-primary"
    style={{
      marginLeft: "40px", // Space between search and select
    }}
  >
    Search
  </button>

  {/* Reset Button */}
  <button
    className="btn btn-primary"
    onClick={handleReset}
    style={{
      marginLeft: "10px", // Space between the buttons
      // height: "38px", // Consistent height for the button
      // width: "110%", // Adjust width for the Reset button
      // display: "flex",
      // justifyContent: "center", // Centers text horizontally
      // alignItems: "center", // Centers text vertically
      // padding: 0, // No extra padding
    }}
  >
    Reset
  </button>

</div>

    </div>

    {/* New Card Generate Section */}
    <div className="col-md-3 ms-auto">
      <div
        style={{
          border: "1px solid #ccc",
          padding: "10px",
          borderRadius: "5px",
          marginLeft: "60px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h5 style={{ marginBottom: "10px" }}>New Card Generate</h5>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="number"
            placeholder="Max 50 cards generate..."
            onChange={handleqrgeneratenumber}
            className="form-control"
            style={{
              flex: "1", // Allow input to grow in available space
              marginRight: "10px", // Space between input and button
            }}
          />
          <input
            type="button"
            className="btn btn-primary"
            value="Submit"
            onClick={GenerateQR}
            style={{
              height: "38px", // Consistent height
              width: "120px", // Width of the Submit button
            }}
          />
        </div>
      </div>
    </div>
  </div>
</form>


</div>
              </div>
              <hr style={{ marginTop: "10px" }} />

              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
      <div className="spinner-border custom text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  ) : (
    <>
    <div className="table-responsive" style={{ overflowX: 'auto' }}>
      <table className="display dataTable" id="advance-1" style={{ whiteSpace: 'nowrap' }}>
      <thead>
  <tr>
    <th>SrNo</th>
    <th><input type="text" placeholder="Backend RFID Code" onChange={(e) => handleSearch('backend_rfid_code', e.target.value)}/></th>
    <th><input type="text" placeholder="RFID Sr No" onChange={(e) => handleSearch('serial_number', e.target.value)}/></th>
    <th><input type="text" placeholder="Mobile Number" onChange={(e) => handleSearch('mobileNumber', e.target.value)}/></th>
    <th><input type="text" placeholder="Assign User" onChange={(e) => handleSearch('assignUser', e.target.value)}/></th>
    <th><input type="text" placeholder="Assign Date" onChange={(e) => handleSearch('assignDate', e.target.value)}/></th>
    <th><input type="text" placeholder="Qr Code" onChange={(e) => handleSearch('qrCode', e.target.value)}/></th>
    <th>QR Code ID</th>
    <th><input type="text" placeholder="Link With" onChange={(e) => handleSearch('linkWith', e.target.value)}/></th>
    <th><input type="text" placeholder="Card Limit" onChange={(e) => handleSearch('cardLimit', e.target.value)}/></th>
    <th><input type="text" placeholder="Assign From" onChange={(e) => handleSearch('assignFrom', e.target.value)} /></th>
 
    <th>Station Name</th>
    <th>Offer Amount</th>
    <th>Assign Amount</th>
    <th>Status</th>
    <th><input type="text" placeholder="Created Date" onChange={(e) => handleSearch('createdDate', e.target.value)}/></th>
  </tr>
</thead>

        <tbody>
          {displayedData.length === 0 ? (
          <tr>
          <td colSpan="12" className="text-center">
          <h5>No Data Found</h5>
          </td>
        </tr>
        
          ) : (
            displayedData?.map((rfid, index) => (
              <tr key={index}>
                <td>{(page - 1) * Limit + index + 1}</td>
                <td>{rfid?.backend_rfid_code}</td>
                <td>{rfid?.serial_number}</td>
                <td>{rfid?.assignedUser?.mobile}</td>
                <td>{rfid?.assignedUser?.name}</td>
                <td>{rfid?.assign_date}</td>
                <td>
                  <QRCodeCanvas value={rfid?.UPI_url_link} alt="QR Code" style={{ width: '100px', height: '100px' }} />
                </td>

          
                <td>{rfid?.qr_code_id}</td>
                <td>
                  <a href={rfid?.QrLink} target="_blank" rel="noopener noreferrer" title = "Download QR">
                    {rfid?.QrLink}
                  </a>
                </td>
                <td>{rfid?.limit}</td>
              
                <td>
                <Select
  styles={{ container: base => ({ ...base, width: '180px' }) }}
  value={Users.map(user => ({
    value: user._id,
    label: `${user.name} (${user.mobile})`,
  })).find(option => option.value === rfid?.assign_user_id)} // Match format with options
  onChange={(selectedOption) => handleSelectChange(rfid?._id, selectedOption)}
  options={Users.map(user => ({
    value: user._id,
    label: `${user.name} (${user.mobile})`,
  }))}
/>
                </td>
               
                <td>{rfid?.station_name}</td>
                <td>{rfid?.offer_amount}</td>
                <td>{rfid?.assign_amount}</td>
                <td>
                  <select
                    onChange={(e) => handleStatusType(e, rfid._id)}
                    value={RfidStatuses[rfid._id] || rfid.status}
                    className="custom-select"
                    id="statusType"
                    style={{ width: "90px" }}
                    name="statusType"
                  >
                    <option value="Active">Active</option>
                    <option value="InActive">InActive</option>
                    <option value="Deleted">Deleted</option>
                  </select>
                </td>
                <td>{rfid?.createdAt}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

    </div>
    
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RFID;
